import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Items,
  ListItem,
  Loading,
  LoadingDiv,
  LoadingWrap,
  ProjectList,
  Text,
  Title
} from '../searchRepositoryModal/styles';
import { getVercelProjectList } from '../../../services/vercelService';
import { VercelProject } from '../../../mobx/interfaces/project';
import { isEmpty } from '../../../helpers/common';
import { EMPTY_STATE_SIZE } from '../../../global/constants';
import { observer } from 'mobx-react-lite';
import EmptyStateV2 from '../../emptyState';
import ModalHeader from '../modalHeader';

interface Props {
  onClose?: () => void;
  handleSelect: (project: VercelProject) => void;
}
function VercelIntegrationModal({ onClose, handleSelect }: Props) {
  //Use state variables
  const [loading, setLoading] = useState(false);
  const [vercelProjects, setVercelProjects] = useState<VercelProject[]>([]);
  const [filteredProjects, setFilteredProjects] = useState<VercelProject[]>([]);

  //Get load vercel project list
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const vercelProjectList = await getVercelProjectList();
      setVercelProjects(vercelProjectList || []);
      setFilteredProjects(vercelProjectList || []);
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  //Handle repository search
  const handleSearch = useCallback(
    (value: string) => {
      const searchNewText = value.trim().toLowerCase();
      if (searchNewText === '') {
        setFilteredProjects(vercelProjects);
        return;
      }
      const words = searchNewText.split(' ').filter((word) => word.length > 0);
      const updatedList = vercelProjects?.filter((item) => {
        const title = item?.name.trim().toLowerCase() || '';
        return words.some((word) => title.includes(word));
      });
      setFilteredProjects(updatedList);
    },
    [vercelProjects]
  );

  return (
    <>
      <ModalHeader placeHolder='Search vercel projects...' onSearchChange={(e) => handleSearch(e)} onClose={onClose} />
      <ProjectList>
        {!loading && !isEmpty(vercelProjects) && !isEmpty(filteredProjects) && <Title>Projects</Title>}
        {!loading && isEmpty(vercelProjects) && (
          <Box>
            <EmptyStateV2 title='No Projects' size={EMPTY_STATE_SIZE.SMALL} imageUrl={'empty_repo'} />
          </Box>
        )}
        {loading && (
          <Box>
            <LoadingDiv>
              <LoadingWrap>
                <Loading />
              </LoadingWrap>
              <Text>Loading...</Text>
            </LoadingDiv>
          </Box>
        )}
        {!loading && !isEmpty(vercelProjects) && isEmpty(filteredProjects) && (
          <Box>
            <EmptyStateV2
              title='No search results found.'
              description='Try changing your search term.'
              size={EMPTY_STATE_SIZE.SMALL}
              imageUrl={'no_repo_found'}
            />
          </Box>
        )}
        {!loading && !isEmpty(vercelProjects) && !isEmpty(filteredProjects) && (
          <Items>
            {filteredProjects.map((project) => (
              <ListItem role='button' key={project.id} onClick={() => handleSelect(project)}>
                <p>{project.name}</p>
              </ListItem>
            ))}
          </Items>
        )}
      </ProjectList>
    </>
  );
}
export default observer(VercelIntegrationModal);
